// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "bizneo-widget" + "." + "8b5b40ff" + ".chunk.js";
};